module.exports = __webpack_public_path__ + "static/media/anonimo~ycuTpJKV.af00f079.png";